<script setup lang="ts">
import Dropdown from "primevue/dropdown";
import type { currentPriceConfig } from "@/components/StudentFulfillment/components/modals/types";
import type { Reason } from "../types";

interface Props {
  modelValue: string | null;
  reasons: Reason[];
  error: boolean;
  errorMessage?: string;
  inputId?: string;
  disabled?: boolean;
  currentSessionPricing: currentPriceConfig;
}

const props = defineProps<Props>();

const emit = defineEmits<(e: "update:modelValue", value: string | null) => void>();
</script>
<template>
  <div class="col-start-2 col-span-2 pt-5 flex items-center" v-if="currentSessionPricing.display">
    <div class="text-sm font-semibold">
      Current Product Price: <span class="font-normal">{{ currentSessionPricing.currentPriceFormatted }}</span>
    </div>
  </div>
  <div class="col-start-2 col-span-2 pt-5 flex items-center">
    <label :for="inputId" class="whitespace-nowrap text-sm font-semibold block mr-2">
      Keep Order Price Reason
    </label>
    <Dropdown
      :model-value="modelValue"
      @update:model-value="emit('update:modelValue', $event)"
      :options="reasons"
      optionLabel="name"
      optionValue="id"
      :id="inputId"
      :disabled="disabled"
      class="md:w-full flex-1"
      :invalid="error"
      placeholder="Select a reason"
    >
      <template #option="optionSlotProps">
        <p>
          {{ optionSlotProps.option.name }}
        </p>
        <p class="ml-4 mt-2 text-gray-600 text-sm">
          {{ optionSlotProps.option.description }}
        </p>
      </template>
    </Dropdown>
  </div>
  <p v-if="error" class="common-error-text col-start-2 col-span-2 text-right">
    {{ errorMessage }}
  </p>
</template>
